import PropTypes from 'prop-types';
import React from 'react';
import SalesRentals from './sales-rentals';
import DropdownSelect from '../shared/dropdown-select/dropdown-select';

import {bannerOptions, sortFields} from '../shared/util';

const ResultsHeader = ({changeFilter, resultState, isGlobal}) => {
  const handleSelect = (option, id) => {
    changeFilter(id, option.value);
  };

  let bannerFilter = isGlobal ? "" : (
    <DropdownSelect
      label="Showing"
      id="bannerFilter"
      options={bannerOptions}
      handleChange={handleSelect}
      selected={resultState.filter.bannerFilter}
    />
  );

  return (
    <div className="container" id="results-title">
      <div id="human-readable-filter" className="for-light col-xs-11 col-xxs-16 flush-left">
        <div className="header-dropdowns">
          {bannerFilter}
          <DropdownSelect
            label="Sorted by"
            id="sortField"
            options={sortFields}
            handleChange={handleSelect}
            selected={resultState.filter.sortField}
          />
        </div>
      </div>
      <div className="col-xs-5 col-xxs-16">
        <SalesRentals
          changeFilter={changeFilter}
          resultState={resultState}
        />
      </div>
    </div>
  );
};

ResultsHeader.propTypes = {
  changeFilter: PropTypes.func.isRequired,
  resultState: PropTypes.object.isRequired
}

export default ResultsHeader;



// WEBPACK FOOTER //
// ./src/components/my-listings/results-header.js